import { defineStore } from "pinia";
import { computed } from "vue";
import { pickBy } from "lodash-es";
import { useSceneNodesStore } from "../scene/sceneNodes.store";
import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { Subset } from "@/helpers/utility/Type";
import type { SceneLayerData } from "./sceneLayerData";

export const useSceneLayerStore = defineStore("model/sceneLayers", () => {
  const sceneNodeStore = useSceneNodesStore();

  function isLayerItem(item: SceneNodeItem): item is SceneNodeItem<"layer"> {
    return item.dataType === "layer";
  }

  async function create(options: Subset<SceneNodeItem<"layer">>, data: Partial<SceneLayerData> = {}) {
    const filledData: SceneLayerData = {
      layerType: "scene",
      ...options.data,
      ...data,
    };
    return await sceneNodeStore.create({
      ...options,
      parentSceneNodeUid: null,
      dataType: "layer",
      data: filledData,
    });
  }

  const items = computed(() => {
    return pickBy(sceneNodeStore.items, isLayerItem) as Record<number, SceneNodeItem<"layer">>;
  });

  const byUid = computed(() => {
    return pickBy(sceneNodeStore.byUid, isLayerItem) as Record<string, SceneNodeItem<"layer">>;
  });

  function $reset() {
    // handled by sceneNodeStore.
    return;
  }

  return {
    create,
    items,
    byUid,
    $reset
  }
});
